module.exports = __webpack_public_path__ + "static/offer-brand-basic-5-fa1bf046540e734e806fadcae08a3c80.jpg";